import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../mensajes';

import { validaSoloNumero, formatMoneda, validaMonto, formatoMonto } from '../../util/varios';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import TablaPuc from './modalTablaPuc';
import axios from 'axios';
import { Dimmer } from '../spinner';


export const ActualizarProducto = (props) => {

    /*  variables de estados */

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../src/modulos/datos');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [contar1, setContar1] = useState(0);
    const [activate, setActivate] = useState(false);
    const txtTipoProducto = useRef();
    const txtUnidadmedida = useRef();
    const txtStock = useRef();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [idUsuario, setIdUsuario] = useState();
    const [declaWeb, setDeclaWeb] = useState();
    const [bloqueado, setBloqueado] = useState(false);
    const [idefiscal, setIdefiscal] = useState(localStorage.getItem('idefiscal'));
    const txtDescrp = useRef();
    const txtServicio = useRef();
    const txtExento = useRef();
    const txtAlmacen = useRef();
    const txtIdc = useRef();
    const [visibleF, setVisibleF] = useState('hidden');
    const [habilitadoNR, setHabilitadoNR] = useState(false);
    const [values, setValues] = useState({
        idproducto: '',
        descripcion: '',
        idunidadmedida: '',
        idtipoproducto: '',
        exento: '',
        almacen: '',
        stockminimo: 0.00,
        servicio: ''
    });

    const [status, setStatus] = useState();

    const onChange = (event) => {

        if (event.target.name === 'descripcion') {
            event.target.value = event.target.value.toUpperCase();
        }
        setValues({ ...values, [event.target.name]: event.target.value });
    };

    const onCheck = () => {

        if (txtServicio.current.checked) {
            setBloqueado(true);
        } else {

            setBloqueado(false);
        }
        
        if (txtAlmacen.current.checked){
            setVisibleF('visible')
        }else{
            setVisibleF('hidden')
        }
    }

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.which === 13) {
                if (event.target.id === 'inputStock') {
                    txtStock.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };


    const Actualizar = (operacion) => {

        let endpoint = `${op.conexion}/api/comprasAlmacen/createProducto/${operacion}`;
        let body;
        setActivate(true);

        body = {
            nid: parseInt(txtIdc.current.value),
            descr: txtDescrp.current.value.trim(),
            unmed: txtUnidadmedida.current.value,
            tiprod: txtTipoProducto.current.value,
            exent: txtExento.current.checked ? true : false,
            alma: txtAlmacen.current.checked ? true : false,
            minimo: txtStock.current.value.trim().replace(/\./g, '').replace(',', '.'),
            servi: txtServicio.current.checked ? true : false
        };

        console.log(body)

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                props.onHideRenderizar()

                if (props.operacion === 1) {


                    setTitulo("Notificacion");
                    setMsg("Registro Creado Correctamente.")
                    setMostrar(true)

                } else if (props.operacion === 2) {

                    setTitulo("Notificacion");
                    setMsg("Registro Modificado Correctamente.")
                    setMostrar(true)

                } else if (props.operacion === 3) {

                    setTitulo("Notificacion");
                    setMsg("Registro Eliminado Correctamente.")
                    setMostrar(true)

                }

            }
            setActivate(false);
        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    /* const Actualizar = (operacion) => {

        let endpoint = `${op.conexion}/api/comprasAlmacen/createCuentaConta/${operacion}`;
        let body;
        setActivate(true);

        body = {
            nid: parseInt(txtIdc.current.value),
            descrip: txtDescrp.current.value.trim(),
            idplan: valuespuc.idpuc,
            efis: idefiscal,
            plan: valuespuc.puc,
            inform: txtRadioSi.current.checked ? true : false,
            idcta: valuescnt.idcuenta

        };

        console.log(body)

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                props.onHideRenderizar()

                if (props.operacion === 1) {


                    setTitulo("Notificacion");
                    setMsg("Registro Creado Correctamente.")
                    setMostrar(true)

                } else if (props.operacion === 2) {

                    setTitulo("Notificacion");
                    setMsg("Registro Modificado Correctamente.")
                    setMostrar(true)

                } else if (props.operacion === 3) {

                    setTitulo("Notificacion");
                    setMsg("Registro Eliminado Correctamente.")
                    setMostrar(true)

                }

            }
            setActivate(false);
        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }
 */
    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtTipoProducto.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe Seleccionar el Tipo de Producto');
            sigue = false;
            txtTipoProducto.current.focus();
            setMostrar(true);
        }else if (txtUnidadmedida.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe Seleccionar la Unidad de Medida');
            sigue = false;
            setTabIndex(0);
            txtUnidadmedida.current.focus();
            setMostrar(true);
        }else if (txtDescrp.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La Descripción del Producto no debe ir Vacia');
            sigue = false;
            setTabIndex(0);
            txtDescrp.current.focus();
            setMostrar(true);
        }else if (sigue === true) {

            Actualizar(props.operacion)
        }
    }

    const blanquear = () => {

        setVisible(false);
        setMostrar1(false);
        setActivate(false);
        setValues({
            idproducto: '',
            descripcion: '',
            idunidadmedida: '',
            idtipoproducto: '',
            exento: '',
            almacen: '',
            stockminimo: 0.00,
            servicio: ''
        });
        setTabIndex(0);
        setOperacion(0);
        setBloqueado(false);
        setVisibleF('hidden');
        setMsg('');

    }

    const handleCloseMensa = (e) => {
        e.preventDefault();
        setMostrar(false);
        if (msg == 'Registro Creado Correctamente.' || msg == 'Registro Modificado Correctamente.' || msg == 'Registro Eliminado Correctamente.') {
            blanquear();
            props.onHideCancela();

        }

    }


    const cancelar = (e) => {
        e.preventDefault();
        setHabilitadoNR(false);
        blanquear();
        props.onHideCancela();

    }


    const handlerClickTab = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        if (operacion === 1 && (index === 2 || index === 3)) {
            setTabIndex(0);
        } else {
            setTabIndex(index);
        }
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setVisible(false);
                btnAcepta.current.focus();
                setOperacion(props.operacion);
                setTabIndex(0);
                if (props.operacion !== 1) {
                    setValues(props.producto);
                    if (props.producto.servicio === true) {
                        setBloqueado(true);
                    } else {
                        setBloqueado(false);
                    }
                    if(props.producto.almacen === true){
                        setVisibleF('visible');
                    }else{
                        setVisibleF('hidden');
                    }
                }
                console.log(props.tipopro)

            }}

        >
            <Modal.Header style={{ backgroundColor: "rgb(000, 115, 123)" }}>
                <Modal.Title style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif' }}>{operacion === 1 ? 'Agregar Producto2 .' : operacion === 2 ? 'Modificar Producto.' : operacion === 3 ? 'Eliminar Producto.' : 'Consultar Producto.'}</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1}
                    onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div>
                    {/* font-family: 'Times New Roman', Times, serif; */}
                    <div className='row border rounded mx-auto py-4' style={{ fontFamily: 'Times New Roman, Times, serif' }}>
                        <div className='container'>
                            <h3 style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold' }}>Productos/Servicios</h3>
                            <hr />
                        </div>
                        <div className='container col-md-12 py-2'>
                            <div className="container row">
                                <div className="input-group input-group-sm mb-3 col-md-4">
                                    <div className="input-group-prepend" style={{ width: 100 }}>
                                        <span className="input-group-text w-100" id="inputGroup-sizing-sm">Código: </span>
                                    </div>
                                    <input type="text" disabled={true} ref={txtIdc} className="form-control col-md-4" name='idproducto' value={values.idproducto} id="inputCodigo" />
                                </div>
                                <div className="input-group input-group-sm mb-3 col-md-4">
                                    <div className="container row">
                                        <label className=''>Es un Servicio?: &nbsp;</label>
                                        <input type="checkbox" style={{ width: '15px', height: '15px' }} ref={txtServicio} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} defaultChecked={props.producto && props.producto.servicio === true ? true : false} onChange={onCheck} className="form-control form-control-sm" id="#" />
                                    </div>
                                </div>
                                <div className="input-group input-group-sm mb-3 col-md-4">
                                    <div className="container row">
                                        <label className=''>Exento de IVA: &nbsp;</label>
                                        <input type="checkbox" style={{ width: '15px', height: '15px' }} ref={txtExento} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} defaultChecked={props.producto && props.producto.exento === true ? true : false} className="form-control form-control-sm" id="#" />
                                    </div>
                                </div>
                            </div>
                            <div className="container row">
                                <div className="input-group input-group-sm mb-3 col-md-12">
                                    <div className="input-group-prepend" style={{ width: 150 }}>
                                        <span className="input-group-text w-100">Tipo de Producto: </span>
                                    </div>
                                    <select name='idtipoproducto' disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtTipoProducto} value={values ? values.idtipoproducto : ''} onChange={onChange} className="form-control text-uppercase" id="inputFechaReg">
                                        <option value={""}>SELECCIONAR TIPO DE PRODUCTO</option>
                                        {props.tipopro && props.tipopro.map((item, index) => (
                                            <option key={index} value={item.idtipoproducto} > {item.descripcion} </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="container row">
                                <div className="input-group input-group-sm mb-3 col-md-12">
                                    <div className="input-group-prepend" style={{ width: 150 }}>
                                        <span className="input-group-text w-100">Unidad de Medida: </span>
                                    </div>
                                    <select name='idunidadmedida' disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtUnidadmedida} value={values ? values.idunidadmedida : ''} onChange={onChange} className="form-control text-uppercase" id="inputFechaReg">
                                        <option value={""}>SELECCIONAR UNIDAD DE MEDIDA</option>
                                        {props.unidad && props.unidad.map((item, index) => (
                                            <option key={index} value={item.idunidadmedida} > {item.descripcion} </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='container row'>
                                <div className="input-group input-group-sm mb-3 col-md-12">
                                    <div className="input-group-prepend" style={{ width: 150 }}>
                                        <span className="input-group-text w-100">Descripción: </span>
                                    </div>
                                    <textarea type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtDescrp} name='descripcion' className="form-control text-uppercase" onChange={onChange} defaultValue={values.descripcion.trim()} id="inputDescripcion" />
                                </div>
                            </div>
                            <div className='container row'>
                                <div className="input-group input-group-sm mb-3 col-md-12">
                                    <div className="container row">
                                        <label className=''>Almacen: &nbsp;</label>
                                        <input type="checkbox" style={{ width: '15px', height: '15px' }} ref={txtAlmacen} disabled={operacion === 4 || operacion === 3 || bloqueado === true ? true : deshabilitado} defaultChecked={props.producto && props.producto.almacen === true ? true : false} onChange={onCheck} className="form-control form-control-sm" id="#" />

                                        <div className="ml-4 row" style={{visibility: visibleF }}>
                                            <label className=''>Stock Minimo: &nbsp;</label>
                                            <input type="input" ref={txtStock} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} defaultValue={values && values.stockminimo ? formatMoneda(values.stockminimo.replace(',', '').replace('.', ','), ',', '.', 2) ? formatMoneda(values.stockminimo.replace(',', '').replace('.', ','), ',', '.', 2) : '' : '0,00'} className="form-control col-md-4 form-control-sm" onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="inputStock" />

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "" }}>
                <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-success col-md-2"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-secondary col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}